/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ delta: NonNullable<unknown> }} Body_Assessment_Compare_Delta_WhtrInputs */

const en_us2_body_assessment_compare_delta_whtr = /** @type {(inputs: Body_Assessment_Compare_Delta_WhtrInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Waist ÷ height: ${i?.delta}`)
};

const pt_br2_body_assessment_compare_delta_whtr = /** @type {(inputs: Body_Assessment_Compare_Delta_WhtrInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Cintura ÷ altura: ${i?.delta}`)
};

const es_419_body_assessment_compare_delta_whtr = /** @type {(inputs: Body_Assessment_Compare_Delta_WhtrInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Cintura ÷ estatura: ${i?.delta}`)
};

const pt_pt2_body_assessment_compare_delta_whtr = /** @type {(inputs: Body_Assessment_Compare_Delta_WhtrInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Cintura ÷ altura: ${i?.delta}`)
};

const fr_fr2_body_assessment_compare_delta_whtr = /** @type {(inputs: Body_Assessment_Compare_Delta_WhtrInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Taille ÷ hauteur : ${i?.delta}`)
};

const de_de2_body_assessment_compare_delta_whtr = /** @type {(inputs: Body_Assessment_Compare_Delta_WhtrInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Taille ÷ Größe: ${i?.delta}`)
};

const it_it2_body_assessment_compare_delta_whtr = /** @type {(inputs: Body_Assessment_Compare_Delta_WhtrInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Vita ÷ altezza: ${i?.delta}`)
};

/**
* | output |
* | --- |
* | "Waist ÷ height: {delta}" |
*
* @param {Body_Assessment_Compare_Delta_WhtrInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const body_assessment_compare_delta_whtr = /** @type {((inputs: Body_Assessment_Compare_Delta_WhtrInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Body_Assessment_Compare_Delta_WhtrInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_body_assessment_compare_delta_whtr(inputs)
	if (locale === "es-419") return es_419_body_assessment_compare_delta_whtr(inputs)
	if (locale === "pt-PT") return pt_pt2_body_assessment_compare_delta_whtr(inputs)
	if (locale === "fr-FR") return fr_fr2_body_assessment_compare_delta_whtr(inputs)
	if (locale === "de-DE") return de_de2_body_assessment_compare_delta_whtr(inputs)
	if (locale === "it-IT") return it_it2_body_assessment_compare_delta_whtr(inputs)
	return en_us2_body_assessment_compare_delta_whtr(inputs)
});
export { body_assessment_compare_delta_whtr as "body-assessment.compare_delta_whtr" }